import { render, staticRenderFns } from "./news-and-media-list-page.vue?vue&type=template&id=2c903cbe&scoped=true"
import script from "./news-and-media-list-page.vue?vue&type=script&lang=js"
export * from "./news-and-media-list-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c903cbe",
  null
  
)

export default component.exports